import {AlertMessage} from "./data/AlertMsg";

export const HTTP_ERR = {
  CLIENT_ERROR: "4XX",
  SERVER_ERROR: "INTERNAL_SERVER_ERROR",
  AUTH_ERROR: 401,
  FORBIDDEN_ERROR: 403,
  TIMEOUT_ERROR: "http-timeout",
  CONNECTION_REFUSED: "CONNECTION_REFUSED",
};


export type ErrorResponse = Array<{
  errorKey: string
  errorMessage: string
}>

export const getErrFromResponse = (err) => {
  let customErrCode: string | number = HTTP_ERR.CONNECTION_REFUSED;
  const errCode = err.code;
  const errData = err.response?.data;
  const statusCode = err.response?.status;
  if (errCode === "ECONNABORTED") {
    customErrCode = HTTP_ERR.TIMEOUT_ERROR;
  }
  if (statusCode === HTTP_ERR.AUTH_ERROR) {
    customErrCode = HTTP_ERR.AUTH_ERROR;
  } else if (statusCode === HTTP_ERR.FORBIDDEN_ERROR) {
    customErrCode = HTTP_ERR.FORBIDDEN_ERROR;
  } else if (statusCode >= 400) {
    customErrCode = HTTP_ERR.CLIENT_ERROR;
  }
  if (statusCode >= 500) {
    customErrCode = HTTP_ERR.SERVER_ERROR;
  }
  return {errData, customErrCode};
};

export function getErrorMessage(error) {
  const {errData, customErrCode} = getErrFromResponse(error);
  let errorMessage = AlertMessage.axiosErrors.serverError;
  switch (customErrCode) {
    case HTTP_ERR.AUTH_ERROR:
      errorMessage = errData.errors[0].errorMessage;
      break;
    case HTTP_ERR.FORBIDDEN_ERROR:
      errorMessage = errData.errors[0].errorMessage;
      break;
    case HTTP_ERR.CLIENT_ERROR:
      errorMessage = errData.errors[0].errorMessage;
      break;
    case HTTP_ERR.SERVER_ERROR:
      errorMessage = AlertMessage.axiosErrors.serverError;
      break;
    case HTTP_ERR.TIMEOUT_ERROR:
      errorMessage = AlertMessage.axiosErrors.timeoutError;
      break;
    case HTTP_ERR.CONNECTION_REFUSED:
      errorMessage = AlertMessage.axiosErrors.connectionRefused;
      break;
    default:
  }
  return errorMessage;
}

export function getErrorResponse(error: any) {
  const {errData} = getErrFromResponse(error);
  return errData.errors as ErrorResponse;
}

export const FindErrorResponseType = {
  isServerError(err) {
    const {customErrCode} = getErrFromResponse(err);
    if (customErrCode === HTTP_ERR.SERVER_ERROR) {
      return true
    }
  },
  isClientError(err) {
    const {customErrCode} = getErrFromResponse(err);
    if (customErrCode === HTTP_ERR.CLIENT_ERROR) {
      return true
    }
  },
}

class Error {
    errorKey: string
    errorMessage: string

    constructor(error: Error) {
        this.errorKey = error.errorKey
        this.errorMessage = error.errorMessage
    }
}

export class AuthzErrors {
    errors: Error[]

    constructor(errorOutput: Error[]) {
        this.errors = errorOutput.map((error) => {
            return new Error(error)
        })
    }

    hasKey(errorKey: String):boolean {
        return this.errors.some((error) => error.errorKey === errorKey)
    }
}
